import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './authentication/authentication.service';
import { FirebaseAuthService } from './firebase/firebase-auth.service';

interface LocationHistory {
  currentUser: string | null;
  previousUrl: string | null;
  currentUrl: string | null;
}

@Injectable({ providedIn: 'root' })
export class UrlService {
  private locationHistory: LocationHistory = {
    currentUser: null,
    previousUrl: null,
    currentUrl: null,
  };

  private router = inject(Router);
  private location = inject(Location);
  private authenticationService = inject(AuthenticationService);
  private firebaseAuthService = inject(FirebaseAuthService);
  constructor() {
    this.loadDataFromSessionStorage(
      this.authenticationService.credentials?.username || null
    );
    this.firebaseAuthService.changedUser.subscribe((user: any) => {
      if (user) {
        this.locationHistory.currentUser = user.email;
        this.loadDataFromSessionStorage(user.email);
      } else {
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          !event.url.includes('login') &&
          this.locationHistory.currentUser !== null
        ) {
          this.locationHistory.previousUrl = this.locationHistory.currentUrl?.split('?')[0] ?? '';
          this.locationHistory.currentUrl = event.url?.split('?')[0] ?? '';
          //if (this.locationHistory.previousUrl) {
          this.locationHistory.currentUser =
            this.authenticationService.credentials?.username || null;
          if (this.authenticationService.credentials?.username) {
            sessionStorage.setItem(
              this.authenticationService.credentials?.username,
              JSON.stringify(this.locationHistory)
            );
          }
        }
      }
    });
  }

  public loadDataFromSessionStorage(user: string | null): void {
    if (user !== null) {
      let locationData: any;

      locationData = sessionStorage.getItem(user);
      if (locationData) {
        locationData = JSON.parse(locationData);

        const currentUrl = locationData.currentUrl;

        const previousUrl = locationData.previousUrl;
        this.locationHistory.currentUser = user;

        if (previousUrl) {
          this.locationHistory.previousUrl = previousUrl?.split('?')[0] + '';
        }
        if (currentUrl) {
          this.locationHistory.currentUrl = currentUrl?.split('?')[0] ?? '';
        }
      }
    }
  }

  public goBack(): void {
    this.location.back();
  }
  public getPreviousUrl(): string | null {
    return this.locationHistory.previousUrl;
  }
  public getCurrentUrl(): string | null {
    return this.locationHistory.currentUrl;
  }
}
